import React from 'react';
import '../css/Footer.css';
import GreenfieldLogo from '../assets/logo.jpeg'; // Apne asset ka exact path check karein

const Footer = () => {
  return (
    <footer className="gfi-footer-wrapper">
      
      {/* --- NEW SECTION: TOP CITIES WE SERVE (Screenshot 6 Match) --- */}
      <div className="gfi-top-cities-section">
        <div className="gfi-cities-header">
          <div className="gfi-cities-icon-box">📍</div>
          <h2 className="gfi-cities-title">TOP CITIES WE SERVE</h2>
        </div>
        <div className="gfi-cities-grid-mesh">
          <div className="gfi-city-item">📍 Muzaffarpur</div>
          <div className="gfi-city-item">📍 Siwan</div>
          <div className="gfi-city-item">📍 Gopalganj</div>
          <div className="gfi-city-item">📍 Ballia</div>
          <div className="gfi-city-item">📍 Deoria</div>
          <div className="gfi-city-item">📍 Gorakhpur</div>
          
          <div className="gfi-city-item">📍 Mau</div>
          <div className="gfi-city-item">📍 Varanasi</div>
          <div className="gfi-city-item">📍 Darbhanga</div>
          <div className="gfi-city-item">📍 Ranchi</div>
          <div className="gfi-city-item">📍 Bhagalpur</div>
          <div className="gfi-city-item">📍 Jamshedpur</div>
          
          <div className="gfi-city-item">📍 Bettiah</div>
          <div className="gfi-city-item">📍 Motihari</div>
          <div className="gfi-city-item">📍 Ara Bhojpur</div>
          <div className="gfi-city-item">📍 Kushinagar</div>
          <div className="gfi-city-item">📍 Patna</div>
          <div className="gfi-city-item">📍 Gaya</div>
        </div>
      </div>

      {/* --- EXISTING 5-COLUMN FOOTER CONTENT --- */}
      <div className="gfi-footer-container">
        
        {/* COLUMN 1: BRAND LOGO & PROFILE */}
        <div className="gfi-footer-col brand-summary-col">
          <div className="gfi-footer-logo-area">
            <img src={GreenfieldLogo} alt="Greenfield Academy Logo" />
          </div>
          <p className="gfi-brand-desc">
            Greenfield Industrial Fire and Safety Academy is a leading Fire & Safety and Industrial Safety training institute offering NEBOSH, IOSH, Diploma, and HSE courses with practical training and placement support.
          </p>
          <div className="gfi-badge-row">
            <span className="gfi-fbadge gold-partner">🏅 NEBOSH Gold Partner</span>
            <span className="gfi-fbadge govt-reg">✓ Govt. Registered</span>
            <span className="gfi-fbadge alumni">👥 10,000+ Alumni</span>
          </div>
          <div className="gfi-social-icons">
            <a href="https://www.facebook.com/profile.php?id=100089558869270" className="gfi-social-btn fb" aria-label="Facebook">f</a>
            <a href="https://www.instagram.com/gifsa_gkp?igsh=ZncwbmhvZGE4bmtl" className="gfi-social-btn insta" aria-label="Instagram">📸</a>
            <a href="#linkedin" className="gfi-social-btn ln" aria-label="LinkedIn">in</a>
            <a href="#twitter" className="gfi-social-btn tw" aria-label="X">X</a>
            <a href="https://youtube.com/@greenfieldsafetyhub?si=ryA-EwIJ8FFATyxG" className="gfi-social-btn yt" aria-label="YouTube">▶</a>
          </div>
          <div className="gfi-playstore-btn">
            <a href="#playstore" className="gfi-ps-link">
              <span className="gfi-ps-icon">🤖</span>
              <div className="gfi-ps-text">
                <small>Available on</small>
                <strong>Google Play Store</strong>
              </div>
            </a>
          </div>
        </div>

        {/* COLUMN 2: QUICK LINKS */}
        <div className="gfi-footer-col">
          <h3 className="gfi-footer-heading">
            <span className="gfi-heading-icon">🔗</span> QUICK LINKS
          </h3>
          <ul className="gfi-footer-links-list">
            <li><a href="#about">&gt; About Institute</a></li>
            <li><a href="#director">&gt; Director's Message</a></li>
            <li><a href="#admission">&gt; Admission 2026</a></li>
            <li><a href="#placement">&gt; Placement Cell</a></li>
            <li><a href="#gallery">&gt; Campus Gallery</a></li>
            <li><a href="#franchise">&gt; Franchise</a></li>
            <li><a href="#blog">&gt; Blog & News</a></li>
            <li><a href="#contact">&gt; Contact Us</a></li>
          </ul>
        </div>

        {/* COLUMN 3: POPULAR COURSES */}
        <div className="gfi-footer-col">
          <h3 className="gfi-footer-heading">
            <span className="gfi-heading-icon">🎓</span> POPULAR COURSES
          </h3>
          <ul className="gfi-footer-links-list">
            <li><a href="#nebosh">&gt; NEBOSH IGC</a></li>
            <li><a href="#iosh">&gt; IOSH Managing Safely</a></li>
            <li><a href="#adis">&gt; ADIS (MSBTE)</a></li>
            <li><a href="#fire-safety">&gt; Diploma in Fire & Safety</a></li>
            <li><a href="#cpd">&gt; CPD Fire Safety</a></li>
            <li><a href="#elearning">&gt; E-Learning Courses</a></li>
            <li><a href="#university">&gt; University Programs</a></li>
          </ul>
        </div>

        {/* COLUMN 4: CONTACT US & PORTALS */}
        <div className="gfi-footer-col contact-portals-col">
          <h3 className="gfi-footer-heading">
            <span className="gfi-heading-icon">📞</span> CONTACT US
          </h3>
          
          <div className="gfi-contact-item">
            <div className="gfi-c-icon">🎓</div>
            <div className="gfi-c-details">
              <span className="gfi-c-label">ADMISSIONS</span>
              <strong>+91 9136218362</strong>
              <strong>+91 9136216362</strong>
            </div>
          </div>

          <div className="gfi-contact-item">
            <div className="gfi-c-icon">🌐</div>
            <div className="gfi-c-details">
              <span className="gfi-c-label">NEBOSH / INTERNATIONAL</span>
              <strong>+91 9136216362</strong>
            </div>
          </div>

          <div className="gfi-contact-item">
            <div className="gfi-c-icon">✉️</div>
            <div className="gfi-c-details">
              <span className="gfi-c-label">EMAIL</span>
              <a href="mailto:greenfieldindustrialfiresafety@gmail.com" className="gfi-email-link">greenfieldindustrialfiresafety@gmail.com</a>
            </div>
          </div>

          <div className="gfi-contact-item">
            <div className="gfi-c-icon">📍</div>
            <div className="gfi-c-details">
              <span className="gfi-c-label">HEAD OFFICE</span>
              <p className="gfi-address-p">Kasia - Gorakhpur Rd, near Durga Public school, Kushmi, Jungle Ramgarh Urf Sarka, Uttar Pradesh 273002</p>
            </div>
          </div>

          <h3 className="gfi-footer-heading grid-heading">
            <span className="gfi-heading-icon">💻</span> PORTALS
          </h3>
          <div className="gfi-portals-grid">
            <a href="#student-ims" className="gfi-portal-card">
              <span className="gfi-p-icon">👥</span>
              <span>Student IMS</span>
            </a>
            <a href="#e-learning" className="gfi-portal-card">
              <span className="gfi-p-icon">💻</span>
              <span>E-Learning</span>
            </a>
            <a href="#kyp" className="gfi-portal-card">
              <span className="gfi-p-icon">📝</span>
              <span>KYP Portal</span>
            </a>
            <a href="#webmail" className="gfi-portal-card">
              <span className="gfi-p-icon">✉️</span>
              <span>Webmail</span>
            </a>
          </div>
        </div>

        {/* COLUMN 5: OUR CENTERS & RECOGNITIONS */}
        <div className="gfi-footer-col centers-recognitions-col">
          <h3 className="gfi-footer-heading">
            <span className="gfi-heading-icon">🏢</span> OUR CENTERS
          </h3>
          
          <p className="gfi-state-title">🔹 BIHAR</p>
          <div className="gfi-centers-grid">
            <span className="gfi-center-badge head-office">★ Chapra (H.O.)</span>
            <span className="gfi-center-badge">📍 Siwan</span>
            <span className="gfi-center-badge">📍 Gopalganj</span>
            <span className="gfi-center-badge">📍 Ara</span>
            <span className="gfi-center-badge">📍 Muzaffarpur</span>
            <span className="gfi-center-badge">📍 Patna</span>
            <span className="gfi-center-badge">📍 Maharajganj</span>
            <span className="gfi-center-badge">📍 Mirganj</span>
          </div>

          <p className="gfi-state-title distinct-state">🔹 UTTAR PRADESH</p>
          <div className="gfi-centers-grid">
            <span className="gfi-center-badge">📍 Kushinagar</span>
            <span className="gfi-center-badge">📍 Varanasi</span>
          </div>

          <h3 className="gfi-footer-heading grid-heading">
            <span className="gfi-heading-icon">🏅</span> RECOGNITIONS
          </h3>
          <div className="gfi-recognitions-box">
            <div className="gfi-rec-item">🛡️ NSC India</div>
            <div className="gfi-rec-item">🇬🇧 IOSH UK</div>
            <div className="gfi-rec-item">🥇 NEBOSH Gold</div>
            <div className="gfi-rec-item">🇺🇸 ASSP USA</div>
          </div>
          <div className="gfi-footer-subtext">
            <span>Training Partner: <strong>NSDC | BSDM | MSME</strong></span>
          </div>
        </div>

      </div>

      {/* Copyright Strip Area */}
      <div className="gfi-footer-bottom-bar">
        <p>© 2026 Greenfield Industrial Fire and Safety Academy. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;